import type { CtwFetchFn } from '@ctw/shared/context/ctw-context';
import { type Env, getBffApiBaseUrl } from '@ctw/shared/utils/environments';

export interface SubmitAcknowledgmentAttributes {
  /** The acknowledgment use case, e.g. 'atlas-export-phi'. */
  kind: string;
  /** The disclosure wording/policy version being accepted. */
  version: string;
  /** The exact text shown to the user, retained for self-contained legal proof. */
  disclosureText?: string;
  /** Kind-specific metadata (e.g. patientUpid, jobId). Flat scalars only. */
  context?: Record<string, string | number | boolean>;
}

export interface SubmitAcknowledgmentArgs {
  ctwFetch: CtwFetchFn;
  env: Env;
  authToken: string;
  attributes: SubmitAcknowledgmentAttributes;
}

/**
 * Records a durable, versioned acknowledgment via the BFF. Actor identity and timestamp are
 * derived server-side from the JWT; the client supplies only the kind/version/context and the
 * text it displayed. Returns the raw fetch result so callers own their success/error handling.
 */
export const submitAcknowledgment = ({
  ctwFetch,
  env,
  authToken,
  attributes,
}: SubmitAcknowledgmentArgs): ReturnType<CtwFetchFn> =>
  ctwFetch(`${getBffApiBaseUrl(env)}/v1/acknowledgments`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${authToken}`,
    },
    body: JSON.stringify({
      data: {
        type: 'acknowledgment',
        attributes,
      },
    }),
  });
